import { withStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Dialog from "../../../../../../components/Dialog/Dialog";
import MultiToggleButtons from "../../../../../../components/Button/MultiToggleButtons";
import { tabs } from "../../constants";
import TabOrcamento from "./TabOrcamento";
import { Button } from "../../../../../../components/ui/Buttons";
import CloseIcon from "../../../../../../components/Icon/CloseIcon";
import TabHistoricoAgendamentos from "./TabHistoricoAgendamentos";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import { findAllProcedimentoOdontologicoAuditByProcedimentoOdontologicoId } from "../../../../../../services/AuditoriaService";
import Auditoria from "../../../../../../components/Auditoria/Auditoria";

const Modal = observer(({
  classes,
  open,
  onClose,
  auditoriaStore,
  procedimentoOdontologicoSelected,
  handleRedirect,
  orcamentoSelected,
}) => {
  const [tabSelected, setTabSelected] = useState(tabs.ORCAMENTO);

  const changeTabSelected = (tabSelected) => {
    setTabSelected(tabSelected);
  };

  const loadAudit = async () => {
    auditoriaStore.auditoriaProps = {
      ...auditoriaStore.auditoriaProps,
      auditoria: "o procedimento",
      auditoriaTela: "procedimentoOdontologico",
      pageNumber: 0,
      lastPage: false,
      auditorias: [],
    };

    auditoriaStore.load = {
      query: findAllProcedimentoOdontologicoAuditByProcedimentoOdontologicoId,
      variableName: "procedimentoOdontologicoId",
      variableId: procedimentoOdontologicoSelected?.id,
    };

    await auditoriaStore.loadAuditItems()
  }

  const render = () => {
    const tabsProcedimentosOdontologicos = {
      [tabs.ORCAMENTO]: <TabOrcamento orcamentoSelected={orcamentoSelected} handleRedirect={handleRedirect} />,
      [tabs.HISTORICO_AGENDAMENTO]: <TabHistoricoAgendamentos
        procedimentoOdontologicoSelected={procedimentoOdontologicoSelected}
        orcamentoSelected={orcamentoSelected}
      />,
      [tabs.AUDITORIA]: <Auditoria />,
    }
    return tabsProcedimentosOdontologicos[tabSelected]
  };

  useEffect(() => {
    if (tabSelected === tabs.AUDITORIA) {
      loadAudit();
    }
  }, [tabSelected])

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: classes.dialogPaper }}
      maxWidth="md"
      fullWidth
    >
      <div className={classes.container}>
        <div className={classes.header}>
          <Button onClick={onClose} id="pac-pod-btn-fch" bgColor="#FB7676" shape="circle">
            <CloseIcon />
          </Button>
        </div>
        <MultiToggleButtons
          id="pac-pod-tab-sel"
          options={["Orçamento", "Histórico agendamentos", "Auditoria"]}
          tabSelected={tabSelected}
          changeTabSelected={changeTabSelected}
        />
        {render()}
      </div>
    </Dialog>
  );
});

const styles = {
  dialogPaper: {
    height: "500px",
    width: "630px",
    padding: "16px",
    overflow: "hidden",
  },
  header: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "16px",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    width: "100%",
    height: "100%",
  },
};

const ModalWithStyles = withStyles(styles)(Modal);
export default inject('auditoriaStore')(ModalWithStyles);
